import { Component, createRef } from "react";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxEnum, NSBoxString, NSBoxTextArea, NSBoxURL, NSColumn, NSRow, NSTabPageTab } from "namirasoft-site-react";
import { KubernetesRow, KubernetesInputRow, KubernetesCloud, ServerRow, ProjectRow, EnvironmentRow, KubernetesKubectlConnectType } from "namirasoft-infra";
import { LogGroupRow } from "namirasoft-log";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";
import { FilterItem, FilterItemOperator, NamingConvention } from "namirasoft-core";
import { AWSRow, AzureRow, GCPRow } from "namirasoft-credential";

interface KubernetesEditPageProps extends NSARouterMakerResult, InfraRouterProps
{
    isEdit: boolean;
}

interface KubernetesEditPageState
{
    selected_project_id?: string;
    selected_environment_id?: string;
    kubectl_connect_type?: KubernetesKubectlConnectType;
}

export default class KubernetesEditPage extends Component<KubernetesEditPageProps, KubernetesEditPageState>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxEnum_Cloud = createRef<NSBoxEnum<KubernetesCloud>>();
    NSBoxEntity_ProjectID = createRef<NSBoxEntity<ProjectRow>>();
    NSBoxEntity_EnvironmentID = createRef<NSBoxEntity<EnvironmentRow>>();
    NSBoxEntity_LogGroupID = createRef<NSBoxEntity<LogGroupRow>>();
    NSBoxBoolean_AgentPodInstallationEnabled = createRef<NSBoxBoolean>();
    NSBoxEnum_KubectlConnect_Type = createRef<NSBoxEnum<KubernetesKubectlConnectType>>();
    NSBoxEntity_KubectlRunsOnServerID = createRef<NSBoxEntity<ServerRow>>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID = createRef<NSBoxEntity<ServerRow>>();

    NSBoxEntity_KubectlConnect_AWS_CLI_Credential = createRef<NSBoxEntity<AWSRow>>();
    NSBoxString_KubectlConnect_AWS_CLI_Region = createRef<NSBoxString>();
    NSBoxString_KubectlConnect_AWS_CLI_ClusterName = createRef<NSBoxString>();

    NSBoxEntity_KubectlConnect_Azure_CLI_Credential = createRef<NSBoxEntity<AzureRow>>();
    NSBoxString_KubectlConnect_Azure_CLI_SubscriptionID = createRef<NSBoxString>();
    NSBoxString_KubectlConnect_Azure_CLI_ResourceGroupName = createRef<NSBoxString>();
    NSBoxString_KubectlConnect_Azure_CLI_ClusterName = createRef<NSBoxString>();

    NSBoxEntity_KubectlConnect_GCP_CLI_Credential = createRef<NSBoxEntity<GCPRow>>();
    NSBoxString_KubectlConnect_GCP_CLI_ProjectID = createRef<NSBoxString>();
    NSBoxString_KubectlConnect_GCP_CLI_RegionName = createRef<NSBoxString>();
    NSBoxString_KubectlConnect_GCP_CLI_ClusterName = createRef<NSBoxString>();

    NSBoxURL_KubectlConnect_CCA_KubernetesApiServerEndpoint = createRef<NSBoxURL>();
    NSABoxSecret_KubectlConnect_CCA_ClientCertificateSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_CCA_ClientPrivateKeySecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_CCA_ClusterCACertificateSecretID = createRef<NSABoxSecret>();

    NSBoxURL_KubectlConnect_OIDC_SSO_KubernetesApiServerEndpoint = createRef<NSBoxURL>();
    NSBoxURL_KubectlConnect_OIDC_SSO_OIDCIssuerURL = createRef<NSBoxURL>();
    NSABoxSecret_KubectlConnect_OIDC_SSO_ClientIdSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_OIDC_SSO_ClientSecretSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_OIDC_SSO_UsernameSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_OIDC_SSO_ClusterCaCertificateSecretID = createRef<NSABoxSecret>();

    NSBoxURL_KubectlConnect_Kubeconfig_FileKubernetesApiServerEndpoint = createRef<NSBoxURL>();
    NSABoxSecret_KubectlConnect_Kubeconfig_FileFileContentSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_KubectlConnect_Kubeconfig_FileClusterCaCertificateSecretID = createRef<NSABoxSecret>();

    constructor(props: KubernetesEditPageProps)
    {
        super(props);
        this.state = {};
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        let extra_tabs: NSTabPageTab[] = [];

        if (this.state.kubectl_connect_type)
            if (this.state.kubectl_connect_type !== KubernetesKubectlConnectType.AgentPod)
                if (this.state.kubectl_connect_type !== KubernetesKubectlConnectType.ByPreconfigedServer)
                    extra_tabs.push({
                        title: "Kubectl Runs On",
                        clicked: true,
                        getContent: () => (
                            <NSColumn>
                                <NSBoxEntity<ServerRow>
                                    ref={this.NSBoxEntity_KubectlRunsOnServerID}
                                    title="Server"
                                    required={false}
                                    multiple={false}
                                    table_name="server"
                                    list={async (filters, page, size, sorts) =>
                                    {
                                        if (!filters)
                                            filters = [];

                                        if (this.state.selected_environment_id)
                                            filters.push(new FilterItem(
                                                namirasoft.infra.tables.server,
                                                namirasoft.infra.tables.server.columns.environment_id,
                                                false,
                                                FilterItemOperator.all.equals,
                                                this.state.selected_environment_id,
                                            ));

                                        return await this.props.servers.infra.server.List(filters, page, size, sorts, null);
                                    }}
                                    getValue={(item) => item.id}
                                    getTitle={(item) => item.name}
                                    getSort={() => null}
                                    style={{ width: NSBox.width.double }}
                                />
                            </NSColumn>
                        )
                    });


        return (
            <InfraLayout<KubernetesRow, KubernetesInputRow>
                {...this.props}
                pages={{
                    entity: InfraEntities.kubernetes(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): KubernetesInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let cloud = this.NSBoxEnum_Cloud.current?.getValueEnumOne(KubernetesCloud, KubernetesCloud.AWS) ?? KubernetesCloud.AWS;
                                        let project_id = this.NSBoxEntity_ProjectID.current?.getValueOne() ?? "";
                                        let environment_id = this.NSBoxEntity_EnvironmentID.current?.getValueOne() ?? "";
                                        let log_group_id = this.NSBoxEntity_LogGroupID.current?.getValueOne() ?? null;
                                        let agent_pod_installation_enabled = this.NSBoxBoolean_AgentPodInstallationEnabled.current?.getValue() ?? false;
                                        let kubectl_connect_type = this.NSBoxEnum_KubectlConnect_Type.current?.getValueEnumOne(KubernetesKubectlConnectType, KubernetesKubectlConnectType.AgentPod) ?? KubernetesKubectlConnectType.AgentPod;
                                        let kubectl_runs_on_server_id = this.NSBoxEntity_KubectlRunsOnServerID.current?.getValueOne() ?? null;
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        let kubectl_connect_preconfiged_server_server_id = this.NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID.current?.getValueOne() ?? null;

                                        let kubectl_connect_aws_cli_credential = this.NSBoxEntity_KubectlConnect_AWS_CLI_Credential.current?.getValueOne() ?? null;
                                        let kubectl_connect_aws_cli_region = this.NSBoxString_KubectlConnect_AWS_CLI_Region.current?.getValue() ?? null;
                                        let kubectl_connect_aws_cli_cluster_name = this.NSBoxString_KubectlConnect_AWS_CLI_ClusterName.current?.getValue() ?? null;

                                        let kubectl_connect_azure_cli_credential = this.NSBoxEntity_KubectlConnect_Azure_CLI_Credential.current?.getValueOne() ?? null;
                                        let kubectl_connect_azure_cli_subscription_id = this.NSBoxString_KubectlConnect_Azure_CLI_SubscriptionID.current?.getValue() ?? null;
                                        let kubectl_connect_azure_cli_resource_group_name = this.NSBoxString_KubectlConnect_Azure_CLI_ResourceGroupName.current?.getValue() ?? null;
                                        let kubectl_connect_azure_cli_cluster_name = this.NSBoxString_KubectlConnect_Azure_CLI_ClusterName.current?.getValue() ?? null;

                                        let kubectl_connect_gcp_cli_credential = this.NSBoxEntity_KubectlConnect_GCP_CLI_Credential.current?.getValueOne() ?? null;
                                        let kubectl_connect_gcp_cli_project_id = this.NSBoxString_KubectlConnect_GCP_CLI_ProjectID.current?.getValue() ?? null;
                                        let kubectl_connect_gcp_cli_region_name = this.NSBoxString_KubectlConnect_GCP_CLI_RegionName.current?.getValue() ?? null;
                                        let kubectl_connect_gcp_cli_cluster_name = this.NSBoxString_KubectlConnect_GCP_CLI_ClusterName.current?.getValue() ?? null;

                                        let kubectl_connect_cca_kubernetes_api_server_endpoint = this.NSBoxURL_KubectlConnect_CCA_KubernetesApiServerEndpoint.current?.getValue() ?? null;
                                        let kubectl_connect_cca_client_certificate_secret_id = this.NSABoxSecret_KubectlConnect_CCA_ClientCertificateSecretID.current?.getValue() ?? null;
                                        let kubectl_connect_cca_client_private_key_secret_id = this.NSABoxSecret_KubectlConnect_CCA_ClientPrivateKeySecretID.current?.getValue() ?? null;
                                        let kubectl_connect_cca_cluster_ca_certificate_secret_id = this.NSABoxSecret_KubectlConnect_CCA_ClusterCACertificateSecretID.current?.getValue() ?? null;

                                        let kubectl_connect_oidc_sso_kubernetes_api_server_endpoint = this.NSBoxURL_KubectlConnect_OIDC_SSO_KubernetesApiServerEndpoint.current?.getValue() ?? null;
                                        let kubectl_connect_oidc_sso_oidc_issuer_url = this.NSBoxURL_KubectlConnect_OIDC_SSO_OIDCIssuerURL.current?.getValue() ?? null;
                                        let kubectl_connect_oidc_sso_client_id_secret_id = this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientIdSecretID.current?.getValue() ?? null;
                                        let kubectl_connect_oidc_sso_client_secret_secret_id = this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientSecretSecretID.current?.getValue() ?? null;
                                        let kubectl_connect_oidc_sso_username_secret_id = this.NSABoxSecret_KubectlConnect_OIDC_SSO_UsernameSecretID.current?.getValue() ?? null;
                                        let kubectl_connect_oidc_sso_cluster_ca_certificate_secret_id = this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClusterCaCertificateSecretID.current?.getValue() ?? null;

                                        let kubectl_connect_kubeconfig_file_kubernetes_api_server_endpoint = this.NSBoxURL_KubectlConnect_Kubeconfig_FileKubernetesApiServerEndpoint.current?.getValue() ?? null;
                                        let kubectl_connect_kubeconfig_file_file_content_secret_id = this.NSABoxSecret_KubectlConnect_Kubeconfig_FileFileContentSecretID.current?.getValue() ?? null;
                                        let kubectl_connect_kubeconfig_file_cluster_ca_certificate_secret_id = this.NSABoxSecret_KubectlConnect_Kubeconfig_FileClusterCaCertificateSecretID.current?.getValue() ?? null;

                                        return {
                                            workspace_id: "",
                                            name,
                                            cloud,
                                            project_id,
                                            environment_id,
                                            log_group_id,
                                            agent_pod_installation_enabled,
                                            kubectl_connect_type,
                                            kubectl_runs_on_server_id,
                                            description,

                                            kubectl_connect_preconfiged_server_server_id,

                                            kubectl_connect_aws_cli_credential,
                                            kubectl_connect_aws_cli_region,
                                            kubectl_connect_aws_cli_cluster_name,

                                            kubectl_connect_azure_cli_credential,
                                            kubectl_connect_azure_cli_subscription_id,
                                            kubectl_connect_azure_cli_resource_group_name,
                                            kubectl_connect_azure_cli_cluster_name,

                                            kubectl_connect_gcp_cli_credential,
                                            kubectl_connect_gcp_cli_project_id,
                                            kubectl_connect_gcp_cli_region_name,
                                            kubectl_connect_gcp_cli_cluster_name,

                                            kubectl_connect_cca_kubernetes_api_server_endpoint,
                                            kubectl_connect_cca_client_certificate_secret_id,
                                            kubectl_connect_cca_client_private_key_secret_id,
                                            kubectl_connect_cca_cluster_ca_certificate_secret_id,

                                            kubectl_connect_oidc_sso_kubernetes_api_server_endpoint,
                                            kubectl_connect_oidc_sso_oidc_issuer_url,
                                            kubectl_connect_oidc_sso_client_id_secret_id,
                                            kubectl_connect_oidc_sso_client_secret_secret_id,
                                            kubectl_connect_oidc_sso_username_secret_id,
                                            kubectl_connect_oidc_sso_cluster_ca_certificate_secret_id,

                                            kubectl_connect_kubeconfig_file_kubernetes_api_server_endpoint,
                                            kubectl_connect_kubeconfig_file_file_content_secret_id,
                                            kubectl_connect_kubeconfig_file_cluster_ca_certificate_secret_id,

                                            kubernetes_category: [],
                                            kubernetes_field: [],
                                            kubernetes_tag: []
                                        };
                                    },
                                    setRow: (row: KubernetesRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEnum_Cloud.current?.setValue(row.cloud);
                                        this.NSBoxEntity_ProjectID.current?.setValue(row.project_id);
                                        this.NSBoxEntity_LogGroupID.current?.setValue(row.log_group_id);
                                        this.NSBoxBoolean_AgentPodInstallationEnabled.current?.setValue(row.agent_pod_installation_enabled);
                                        this.NSBoxEnum_KubectlConnect_Type.current?.setValue(row.kubectl_connect_type);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);

                                        this.setState(
                                            () => ({
                                                selected_project_id: row.project_id,
                                                selected_environment_id: row.environment_id,
                                                kubectl_connect_type: row.kubectl_connect_type
                                            }),
                                            () =>
                                            {
                                                this.NSBoxEntity_KubectlRunsOnServerID.current?.setValue(row.kubectl_runs_on_server_id);

                                                this.NSBoxEntity_EnvironmentID.current?.setValue(row.environment_id);

                                                this.NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID.current?.setValue(row.kubectl_connect_preconfiged_server_server_id);

                                                this.NSBoxEntity_KubectlConnect_AWS_CLI_Credential.current?.setValue(row.kubectl_connect_aws_cli_credential);
                                                this.NSBoxString_KubectlConnect_AWS_CLI_Region.current?.setValue(row.kubectl_connect_aws_cli_region);
                                                this.NSBoxString_KubectlConnect_AWS_CLI_ClusterName.current?.setValue(row.kubectl_connect_aws_cli_cluster_name);

                                                this.NSBoxEntity_KubectlConnect_Azure_CLI_Credential.current?.setValue(row.kubectl_connect_azure_cli_credential);
                                                this.NSBoxString_KubectlConnect_Azure_CLI_SubscriptionID.current?.setValue(row.kubectl_connect_azure_cli_subscription_id);
                                                this.NSBoxString_KubectlConnect_Azure_CLI_ResourceGroupName.current?.setValue(row.kubectl_connect_azure_cli_resource_group_name);
                                                this.NSBoxString_KubectlConnect_Azure_CLI_ClusterName.current?.setValue(row.kubectl_connect_azure_cli_cluster_name);

                                                this.NSBoxEntity_KubectlConnect_GCP_CLI_Credential.current?.setValue(row.kubectl_connect_gcp_cli_credential);
                                                this.NSBoxString_KubectlConnect_GCP_CLI_ProjectID.current?.setValue(row.kubectl_connect_gcp_cli_project_id);
                                                this.NSBoxString_KubectlConnect_GCP_CLI_RegionName.current?.setValue(row.kubectl_connect_gcp_cli_region_name);
                                                this.NSBoxString_KubectlConnect_GCP_CLI_ClusterName.current?.setValue(row.kubectl_connect_gcp_cli_cluster_name);

                                                this.NSBoxURL_KubectlConnect_CCA_KubernetesApiServerEndpoint.current?.setValue(row.kubectl_connect_cca_kubernetes_api_server_endpoint);
                                                this.NSABoxSecret_KubectlConnect_CCA_ClientCertificateSecretID.current?.setValue(row.kubectl_connect_cca_client_certificate_secret_id);
                                                this.NSABoxSecret_KubectlConnect_CCA_ClientPrivateKeySecretID.current?.setValue(row.kubectl_connect_cca_client_private_key_secret_id);
                                                this.NSABoxSecret_KubectlConnect_CCA_ClusterCACertificateSecretID.current?.setValue(row.kubectl_connect_cca_cluster_ca_certificate_secret_id);

                                                this.NSBoxURL_KubectlConnect_OIDC_SSO_KubernetesApiServerEndpoint.current?.setValue(row.kubectl_connect_oidc_sso_kubernetes_api_server_endpoint);
                                                this.NSBoxURL_KubectlConnect_OIDC_SSO_OIDCIssuerURL.current?.setValue(row.kubectl_connect_oidc_sso_oidc_issuer_url);
                                                this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientIdSecretID.current?.setValue(row.kubectl_connect_oidc_sso_client_id_secret_id);
                                                this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientSecretSecretID.current?.setValue(row.kubectl_connect_oidc_sso_client_secret_secret_id);
                                                this.NSABoxSecret_KubectlConnect_OIDC_SSO_UsernameSecretID.current?.setValue(row.kubectl_connect_oidc_sso_username_secret_id);
                                                this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClusterCaCertificateSecretID.current?.setValue(row.kubectl_connect_oidc_sso_cluster_ca_certificate_secret_id);

                                                this.NSBoxURL_KubectlConnect_Kubeconfig_FileKubernetesApiServerEndpoint.current?.setValue(row.kubectl_connect_kubeconfig_file_kubernetes_api_server_endpoint);
                                                this.NSABoxSecret_KubectlConnect_Kubeconfig_FileFileContentSecretID.current?.setValue(row.kubectl_connect_kubeconfig_file_file_content_secret_id);
                                                this.NSABoxSecret_KubectlConnect_Kubeconfig_FileClusterCaCertificateSecretID.current?.setValue(row.kubectl_connect_kubeconfig_file_cluster_ca_certificate_secret_id);
                                            }
                                        );
                                    }
                                },
                                ui: {
                                    extra_tabs: [
                                        {
                                            title: "Kubectl Connect",
                                            clicked: true,
                                            getContent: () => (
                                                <NSColumn>
                                                    <NSRow>
                                                        <NSBoxEnum<KubernetesKubectlConnectType>
                                                            ref={this.NSBoxEnum_KubectlConnect_Type}
                                                            title="Kubectl Connect Type"
                                                            required
                                                            multiple={false}
                                                            getEnumObject={() => KubernetesKubectlConnectType}
                                                            getTitle={(value) => NamingConvention.auto.convert(value, NamingConvention.Pascal_Case_Space)}
                                                            onChanged={(box) =>
                                                            {
                                                                this.setState(() => ({ kubectl_connect_type: box.getValueOne() as KubernetesKubectlConnectType }));
                                                            }}
                                                            style={{ width: NSBox.width.double }}
                                                        />
                                                    </NSRow>
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.AgentPod &&
                                                        <>
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/agent-pod.png"
                                                                alt="Agent Pod"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.ByPreconfigedServer &&
                                                        <>
                                                            <NSBoxEntity<ServerRow>
                                                                ref={this.NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID}
                                                                title="Connect Server"
                                                                required={false}
                                                                multiple={false}
                                                                table_name="server"
                                                                list={async (filters, page, size, sorts) =>
                                                                {
                                                                    if (!filters)
                                                                        filters = [];

                                                                    if (this.state.selected_environment_id)
                                                                        filters.push(new FilterItem(
                                                                            namirasoft.infra.tables.server,
                                                                            namirasoft.infra.tables.server.columns.environment_id,
                                                                            false,
                                                                            FilterItemOperator.all.equals,
                                                                            this.state.selected_environment_id,
                                                                        ));

                                                                    return await this.props.servers.infra.server.List(filters, page, size, sorts, null);
                                                                }}
                                                                getValue={(item) => item.id}
                                                                getTitle={(item) => item.name}
                                                                getSort={() => null}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/preconfiged-server.png"
                                                                alt="Preconfiged Server"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.AWSCLI &&
                                                        <>
                                                            <NSBoxEntity<AWSRow>
                                                                ref={this.NSBoxEntity_KubectlConnect_AWS_CLI_Credential}
                                                                title="Credential"
                                                                required={false}
                                                                multiple={false}
                                                                table_name="credential"
                                                                table={namirasoft.credential.tables.aws}
                                                                getValue={(item) => item.id}
                                                                getTitle={(item) => item.name}
                                                                getSort={() => null}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSRow>
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_AWS_CLI_Region}
                                                                    title="Region"
                                                                    required={false}
                                                                />
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_AWS_CLI_ClusterName}
                                                                    title="Cluster Name"
                                                                    required={false}
                                                                />
                                                            </NSRow>
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/aws-cli.png"
                                                                alt="AWS CLI"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.AzureCLI &&
                                                        <>
                                                            <NSBoxEntity<AzureRow>
                                                                ref={this.NSBoxEntity_KubectlConnect_Azure_CLI_Credential}
                                                                title="Credential"
                                                                required={false}
                                                                multiple={false}
                                                                table_name="credential"
                                                                table={namirasoft.credential.tables.azure}
                                                                getValue={(item) => item.id}
                                                                getTitle={(item) => item.name}
                                                                getSort={() => null}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSBoxString
                                                                ref={this.NSBoxString_KubectlConnect_Azure_CLI_SubscriptionID}
                                                                title="Subscription ID"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSRow>
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_Azure_CLI_ResourceGroupName}
                                                                    title="Group Name"
                                                                    required={false}
                                                                />
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_Azure_CLI_ClusterName}
                                                                    title="Cluster Name"
                                                                    required={false}
                                                                />
                                                            </NSRow>
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/azure-cli.png"
                                                                alt="Azure CLI"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.GCPCLI &&
                                                        <>
                                                            <NSBoxEntity<GCPRow>
                                                                ref={this.NSBoxEntity_KubectlConnect_GCP_CLI_Credential}
                                                                title="Credential"
                                                                required={false}
                                                                multiple={false}
                                                                table_name="credential"
                                                                table={namirasoft.credential.tables.gcp}
                                                                getValue={(item) => item.id}
                                                                getTitle={(item) => item.name}
                                                                getSort={() => null}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSBoxString
                                                                ref={this.NSBoxString_KubectlConnect_GCP_CLI_ProjectID}
                                                                title="Project ID"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSRow>
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_GCP_CLI_RegionName}
                                                                    title="Region Name"
                                                                    required={false}
                                                                />
                                                                <NSBoxString
                                                                    ref={this.NSBoxString_KubectlConnect_GCP_CLI_ClusterName}
                                                                    title="Cluster Name"
                                                                    required={false}
                                                                />
                                                            </NSRow>
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/gcp-cli.png"
                                                                alt="GCP CLI"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.ClientCertificateAuthentication &&
                                                        <>
                                                            <NSBoxURL
                                                                ref={this.NSBoxURL_KubectlConnect_CCA_KubernetesApiServerEndpoint}
                                                                title="Kubernetes API Server Endpoint"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_CCA_ClientCertificateSecretID}
                                                                title="Client Certificate Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_CCA_ClientPrivateKeySecretID}
                                                                title="Client Private Key Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_CCA_ClusterCACertificateSecretID}
                                                                title="Cluster CA Certificate Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/client-certificate-authentication.png"
                                                                alt="Client Certificate Authentication"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.OIDC_SSO &&
                                                        <>
                                                            <NSBoxURL
                                                                ref={this.NSBoxURL_KubectlConnect_OIDC_SSO_KubernetesApiServerEndpoint}
                                                                title="Kubernetes API Server Endpoint"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSBoxURL
                                                                ref={this.NSBoxURL_KubectlConnect_OIDC_SSO_OIDCIssuerURL}
                                                                title="OIDC Issuer URL"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientIdSecretID}
                                                                title="Client ID Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClientSecretSecretID}
                                                                title="Client Secret Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_OIDC_SSO_UsernameSecretID}
                                                                title="Username Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_OIDC_SSO_ClusterCaCertificateSecretID}
                                                                title="Cluster CA Certificate Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/oidc-sso.png"
                                                                alt="OIDC SSO"
                                                            />
                                                        </>
                                                    }
                                                    {
                                                        this.state.kubectl_connect_type === KubernetesKubectlConnectType.KubeconfigFile &&
                                                        <>
                                                            <NSBoxURL
                                                                ref={this.NSBoxURL_KubectlConnect_Kubeconfig_FileKubernetesApiServerEndpoint}
                                                                title="Kubernetes API Server Endpoint"
                                                                required={false}
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_Kubeconfig_FileFileContentSecretID}
                                                                title="File Content Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <NSABoxSecret
                                                                {...this.props}
                                                                ref={this.NSABoxSecret_KubectlConnect_Kubeconfig_FileClusterCaCertificateSecretID}
                                                                title="Cluster CA Certificate Secret ID"
                                                                required={false}
                                                                auto_complete="new-password"
                                                                style={{ width: NSBox.width.double }}
                                                            />
                                                            <img
                                                                style={{ width: "100%", maxWidth: NSBox.width.double }}
                                                                src="https://static.namirasoft.com/image/namirasoft/infra/diagram/kubernetes/kubectl-connect-type/kubeconfig-file.png"
                                                                alt="Kubeconfig File"
                                                            />
                                                        </>
                                                    }
                                                </NSColumn>
                                            )
                                        },
                                        ...extra_tabs
                                    ]
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSRow>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            title="Name"
                            required
                        />
                        <NSBoxEnum<KubernetesCloud>
                            ref={this.NSBoxEnum_Cloud}
                            title="Cloud"
                            required
                            multiple={false}
                            getEnumObject={() => KubernetesCloud}
                            getTitle={(item) => NamingConvention.auto.convert(item, NamingConvention.Pascal_Case_Space)}
                        />
                    </NSRow>
                    <NSBoxEntity<ProjectRow>
                        ref={this.NSBoxEntity_ProjectID}
                        title="Project"
                        required
                        multiple={false}
                        table_name="project"
                        table={namirasoft.infra.tables.project}
                        getValue={(item) => item.id}
                        getTitle={(item) => item.name}
                        getSort={() => null}
                        onChanged={(box) =>
                        {
                            this.setState(
                                () => ({ selected_project_id: box.getValueOne() ?? undefined }),
                                () =>
                                {
                                    this.NSBoxEntity_EnvironmentID.current?.setValue(null);
                                    this.NSBoxEntity_EnvironmentID.current?.reload();
                                },
                            )
                        }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<EnvironmentRow>
                        ref={this.NSBoxEntity_EnvironmentID}
                        title="Environment"
                        required
                        multiple={false}
                        table_name="environment"
                        list={async (filters, page, size, sorts) =>
                        {
                            if (!filters)
                                filters = [];

                            if (this.state.selected_project_id)
                                filters.push(new FilterItem(
                                    namirasoft.infra.tables.environment,
                                    namirasoft.infra.tables.environment.columns.project_id,
                                    false,
                                    FilterItemOperator.all.equals,
                                    this.state.selected_project_id,
                                ));

                            return await this.props.servers.infra.environment.List(filters, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id}
                        getTitle={(item) => item.name}
                        getSort={() => null}
                        onChanged={(box) =>
                        {
                            this.setState(
                                () => ({ selected_environment_id: box.getValueOne(false) ?? "" }),
                                () =>
                                {
                                    this.NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID.current?.setValue(null);
                                    this.NSBoxEntity_KubectlRunsOnServerID.current?.setValue(null);
                                    this.NSBoxEntity_KubectlConnect_PreconfigedServer_ServerID.current?.reload();
                                    this.NSBoxEntity_KubectlRunsOnServerID.current?.reload();
                                },
                            )
                        }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<LogGroupRow>
                        ref={this.NSBoxEntity_LogGroupID}
                        title="Log Group"
                        required={false}
                        multiple={false}
                        table_name="log-group"
                        table={namirasoft.log.tables.log_group}
                        getValue={(item) => item.id}
                        getTitle={(item) => item.name}
                        getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxBoolean
                        ref={this.NSBoxBoolean_AgentPodInstallationEnabled}
                        title="Agent Pod Installation Enabled"
                        required
                        hideHeader
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        title="Description"
                        required
                        min_length={50}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </InfraLayout>
        );
    }
}